import { Button } from "~/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "~/components/ui/dialog";
import { TEXT } from "~/constants/text";
import { useCocoplusForceUpdate } from "~/hooks/useCocoplusForceUpdate";

/** coco+ App Store リンク（iOS） */
const COCOPLUS_APP_STORE_URL = "https://apps.apple.com/jp/app/id6817950981";

/**
 * coco+(145) かつ旧バージョン(1.1未満)のユーザーに対して
 * 閉じられない全画面ブロックダイアログを表示し、App Store への更新を促す。
 *
 * 条件を満たさない場合（ブラウザ / 新バージョン / 非coco+）は何もマウントしない。
 * `__root.tsx` に 1 個だけマウントする。
 */
export const CocoplusForceUpdateGate = () => {
  const shouldBlock = useCocoplusForceUpdate();

  if (!shouldBlock) return null;

  const handleUpdate = () => {
    window.location.href = COCOPLUS_APP_STORE_URL;
  };

  return (
    // open は常時 true の制御。閉じる手段（onOpenChange / 閉じるボタン / 外側クリック / Esc）を全て塞ぐ
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        overlayClassName="bg-black/60"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        className="flex flex-col items-center gap-6 py-8 text-center"
      >
        <DialogTitle className="text-xl font-bold">
          {TEXT.forceUpdate.title}
        </DialogTitle>
        <p className="whitespace-pre-line text-sm text-muted-foreground">
          {TEXT.forceUpdate.body}
        </p>
        <Button size="lg" className="w-full" onClick={handleUpdate}>
          {TEXT.forceUpdate.button}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
